import { window } from './facade/browser';

export function isBs3(): boolean {
  return window.__theme === 'bs4';
}



// WEBPACK FOOTER //
// ./~/angular-bootstrap-md/utils/ng2-bootstrap-config.ts